.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: var(--border-radius-medium);
  transition: background-color 100ms ease-in-out;
  gap: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    padding: 0.4rem;
  }

  &:hover {
    cursor: pointer;
    background-color: #54575d4d;
  }
}

.icon {
  z-index: 1;
  height: 3.2rem;
  width: 3.2rem;
  min-width: 3.2rem;
  border-radius: var(--border-radius-medium);
  cursor: pointer;
  display: flex;
  font-size: 2.4rem;
  align-items: center;
  justify-content: center;
  color: var(--color-grayscale-cadet);
  background-color: var(--color-grayscale-arsenic);
  fill: currentColor;

  @media screen and (min-width: $bp-medium) {
    //TODO:  Keeping old colors on Desktop until deciding
    color: #1d1f24;
    background-color: #494e5a;
  }
}

.text {
  color: #54575d;

  @media screen and (min-width: $bp-medium) {
    font-size: 1.6rem;
  }
}
